var SPA = window.SPA = (function () {
    var self = {};
    var log = function (msg) { app.console.log('%c%s %s', 'color: brown; font-weight: bold;', '[ROUTER]', msg); };
    var error = function (msg) { app.console.log('%c%s %s', 'color: red; font-weight: bold;', '[ROUTER] ERROR:', msg); };
    var logGroupStart = function (msg) { app.console.group('%c%s\t\t\t\t\t\t\t', 'background: #2F4F4F; color: #FFFACD; font-weight: bold; display: block; text-align: center', msg); };
    var logGroupEnd = function (msg) { app.console.log('%c%s %s', 'color: brown; font-weight: bold;', '[ROUTER]', msg); window.console.groupEnd(); };

    var justLoaded = true;
    var currentScope;
    var setCurrentBinder = function (binder) { self.currentBinder = binder; log('→ Binder set to: ' + binder.name); };
    var setCurrentScope = function (scope) { currentScope = scope; log('→ Scope set to: ' + scope.name); };

    var isSPAEnabled = (typeof globalAppSettings.isSPAEnabled != 'undefined') ? globalAppSettings.isSPAEnabled : false;

    function setPageTitle() {
        if (justLoaded || !isSPAEnabled) {
            return;
        }

        if (currentScope.title !== undefined) {
            document.title = currentScope.title;
        }
        else {
            var title = $('#page-content').data('pagetitle');
            if (title != undefined) {
                document.title = title;
            }
        }
    }

    function generalLeaveHook() {
        logGroupStart('NEW ROUTE (' + router.lastRouteResolved().url + ' → ' + window.location.pathname + ')');
        app.Tooltip.hide();
        justLoaded = false;
        app.enableLoading();
        if (self.currentBinder !== undefined && currentScope !== undefined) {
            self.currentBinder.unBind();
            log('❌ ' + self.currentBinder.name + ' DISABLED.');
            currentScope.stop();
            log('❌ ' + currentScope.name + ' DISABLED.');
        }
        else {
            error('CurrentBinder or CurrentScope not found. Refreshing page...');
            Ajax.redirect(window.location.pathname);
        }
    }

    function generalAfterHook(scopeData) {
        log('⏳ THE ROUTE IS MATCHED. Starting binder... ScopeData=' + JSON.stringify(scopeData));

        if (self.currentBinder !== undefined) {
            self.currentBinder.bind(justLoaded, scopeData);
            log('✓ ' + self.currentBinder.name + ' ENABLED.');
        }
        else {
            error('CurrentBinder not found. Refreshing page...');
            Ajax.redirect(window.location.pathname);
        }

        if (typeof ReturnButton !== 'undefined') {
            ReturnButton.init();
        }
        var activePathname = new CustomEvent('triggerMesssageModal', {
            detail: {
                pathname: window.location.pathname,

            },
            bubbles: true,
          });
        document.dispatchEvent(activePathname);
    }

    var generalHooks = {
        leave: generalLeaveHook,
        after: generalAfterHook
        //before:
        //already:
    };

    var _generalRoute = function (binder, scope, ajaxData, scopeData) {

        if (!isSPAEnabled) {
            router.destroy();
            log('Router destroyed.');
        }

        LayoutResolver.resolve(scope);

        ajaxData = ajaxData || {};
        scopeData = scopeData || {};


        log('⏳ Starting route body...');
        setCurrentBinder(binder);
        setCurrentScope(scope);

        if (justLoaded) {
            currentScope.start(true, scopeData);
            log(currentScope.name + ' JUSTLOADED ENABLED! ');
            return;
        }
        log('Getting Data...');
        Ajax.getJson(self.currentBinder.url, {
            data: ajaxData,
            success: function () {
                log('...Data Received');
                currentScope.start(false, scopeData);
                router.updatePageLinks();
                app.MainNavigation.updatePage();
                setPageTitle();
                logGroupEnd('✓ ' + currentScope.name + ' ENABLED! ');
                app.disableLoading();
            }
        });
    };

    function generalNonSpaRoute() {
        log('General NonSpa Binder');

        router.destroy();
        log('Router destroyed.');
    }

    var live = function () { _generalRoute(BinderLive, ScopeLive); };
    var liveFavorites = function () { _generalRoute(BinderLiveFavorites, ScopeLiveFavorites); };
    var liveSingleSport = function (sport) { _generalRoute(BinderLiveSingleSport, ScopeLiveSingleSport, { sportType: sport }, { sportType: sport }); };

    var prematch = function (sport) { _generalRoute(BinderPrematch, ScopePrematch, { sportType: sport }); };
    var prematchFavorites = function () { _generalRoute(BinderPrematchFavorites, ScopePrematchFavorites); };
    var prematchSingleSport = function (sport) {
        _generalRoute(BinderPrematchSingleSport, ScopePrematchSingleSport, { sportType: sport }, { sportType: sport });
        generalAfterHook({ sportType: sport });
    };

    var history = function () { _generalRoute(BinderHistory, ScopeHistory); };
    var results = function () { _generalRoute(BinderResults, ScopeResults); };
    var event = function (id) { _generalRoute(BinderEvent, ScopeEvent, { id: id }); };
    var bonuses = function (tab) { _generalRoute(BinderBonuses, ScopeBonuses, (tab) ? { tab: tab } : {}); };
    var superexpress = function (num) { _generalRoute(BinderSuperExpress, ScopeSuperExpress, (num) ? { number: num } : {}); };
    var superexpressAll = function () { _generalRoute(BinderAllSuperExpress, ScopeSuperExpress); };


    var router = new Navigo(window.location.origin, false, '#!', true); //TODO: old browser location.origin support
    //CASE SENSITIVE!
    if (globalAppSettings.isLocalizationEnabled) {
        router
            .on('/:lang/live', live, generalHooks)
            .on('/:lang/live/favorites', liveFavorites, generalHooks)
            .on('/:lang/live/:sport', function (params) { return liveSingleSport(params.sport); }, generalHooks)

            .on('/:lang/prematch', prematch, generalHooks)
            .on('/:lang/prematch/favorites', prematchFavorites, generalHooks)
            .on('/:lang/prematch/:sport', function (params) { return prematchSingleSport(params.sport); }, { leave: generalLeaveHook, after: function () { } })
            .on(/^\/([^/\n]+)\/(prematch)\/([^/\n]+)\/(.+)-gid-(\d+)$/, function (eventType, sport, leagueTitle, id) { return prematchSingleSport(sport); }, { leave: generalLeaveHook, after: function () { } })

            .on('/:lang/history', history, generalHooks)
            .on('/:lang/results/:type', results, generalHooks)
            .on('/:lang/results/:type/:sportType', results, generalHooks)

            .on('/:lang/bonuses', bonuses, generalHooks)
            .on('/:lang/bonuses/:tab', function (params) { return bonuses(params.tab); }, generalHooks)

            .on('/:lang/baltsystem', superexpress, generalHooks)
            .on('/:lang/baltsystem/landing', superexpress, generalHooks)
            .on('/:lang/baltsystem/all', superexpressAll, generalHooks)
            .on('/:lang/baltsystem/:num', function (params) { superexpress(params.num); }, generalHooks)

            .on('/:lang/event/:id', function (params) { return event(params.id); }, generalHooks)
            .on(/^\/([^/\n]+)\/(live|prematch)\/(.+)\/(.+)-id-(\d+)$/, function (lang, eventType, sportAndLeague, title, id) { return event(id); }, generalHooks);
    }
    else {
        router
            .on('/live', live, generalHooks)
            .on('/live/favorites', liveFavorites, generalHooks)
            .on('/live/:sport', function (params) { return liveSingleSport(params.sport); }, generalHooks)

            .on('/prematch', prematch, generalHooks)
            .on('/prematch/favorites', prematchFavorites, generalHooks)
            .on('/prematch/:sport', function (params) { return prematchSingleSport(params.sport); }, { leave: generalLeaveHook, after: function () { } })
            .on(/^\/(prematch)\/([^/\n]+)\/(.+)-gid-(\d+)$/, function (eventType, sport, leagueTitle, id) { return prematchSingleSport(sport); }, { leave: generalLeaveHook, after: function () { } })

            .on('/history', history, generalHooks)
            .on('/results/:type', results, generalHooks)
            .on('/results/:type/:sportType', results, generalHooks)

            .on('/bonuses', bonuses, generalHooks)
            .on('/bonuses/:tab', function (params) { return bonuses(params.tab); }, generalHooks)

            .on('/baltsystem', superexpress, generalHooks)
            .on('/baltsystem/landing', superexpress, generalHooks)
            .on('/baltsystem/all', superexpressAll, generalHooks)
            .on('/baltsystem/:num', function (params) { superexpress(params.num); }, generalHooks)

            .on('/event/:id', function (params) { return event(params.id); }, generalHooks)
            .on(/^\/(live|prematch)\/(.+)\/(.+)-id-(\d+)$/, function (eventType, sportAndLeague, title, id) { return event(id); }, generalHooks);
    }

    router.notFound(function (query) {
        log('Route not found. Query="' + query + '"');
        generalNonSpaRoute();
    });


    self.configure = function (config) {
        self._config = $.extend(true, newConfig, self.config || {}, config || {});
    };

    self.resolveRoutes = function () {
        log('Route resolving...');
        var resolved = router.resolve();
        log('Route resolved: ' + JSON.stringify(resolved));
        if (typeof ReturnButton !== 'undefined') {
            ReturnButton.init();
        };
    };



    self.navigate = function (path) {
        if (isSPAEnabled && router !== undefined && !router._destroyed) {
            router.navigate(path);
        }
        else {
            window.location.href = path;
        }
    };

    self.updatePageLinks = function () {
        if (isSPAEnabled) {
            router.updatePageLinks();
        }
    };

    $(function () {
        log('Route resolving...');
        var resolved = router.resolve();
        log('Route resolved: ' + JSON.stringify(resolved));
        if (typeof ReturnButton !== 'undefined') {
            ReturnButton.init();
        }
        app.disableLoading();
    });

    return self;
}());





